import { render } from "./accordion-body.vue?vue&type=template&id=60420b7a"
import script from "./accordion-body.vue?vue&type=script&lang=js"
export * from "./accordion-body.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__